<template lang='pug'>
.boolean-filter
	.bubble(
		@click='updateState'
		:class='state === "" ? "" : `show-${state}`'
	)
</template>

<script>

export default {
	name : 'boolean-filter',

	data : () => ( {
		stateIndex : 0,
		states     : ['', true, false],
	} ),

	computed : {
		state() {
			return this.states[this.stateIndex];
		}
	},

	watch : {
		state( state ) {
			this.$emit( 'filter', state );
		},
	},

	methods : {
		updateState() {
			const nextState = this.stateIndex + 1;

			if ( nextState === this.states.length ) {
				this.stateIndex = 0;

				return;
			}

			this.stateIndex = nextState;
		},
	}
};
</script>

<style lang='scss'>
.boolean-filter {
	width: 30px;
	padding-right: 15px;

	.bubble {
		border: 2px solid $input-color;
		height: 16px;
		width: 16px;
		border-radius: 50%;
		margin-right: 10px;
		cursor: pointer;
		position: relative;

		&.show-true {
			border-color: lighten($color-primary, 15);

			&::before {
				content: ' ';
				position: absolute;
				height: calc( 100% - 4px );
				width: calc( 100% - 4px );
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				background: $color-primary;
				border-radius: 50%;
			}
		}

		&.show-false {
			border-color: lighten($error, 15);

			&::before {
				content: ' ';
				position: absolute;
				height: calc( 100% - 4px );
				width: calc( 100% - 4px );
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				background: $error;
				border-radius: 50%;
			}
		}
	}
}
</style>
